module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-l side-scroll header-navbar-fixed",
    attrs: {
      "id": "page-container"
    }
  }, [_c('header', {
    attrs: {
      "id": "header-navbar"
    }
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed"
  }, [_c('ul', {
    staticClass: "nav-header nav-pills pull-right hidden-xs",
    class: {
      'hidden-sm': _vm.isAdmin
    }
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("\n                        Dashboard\n                    ")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('inspections')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inspections"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("\n                        Inspections\n                    ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('foresters')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foresters"
    }
  }, [_c('i', {
    staticClass: "fa fa-tree"
  }), _vm._v("\n                        Foresters\n                    ")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('profile')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                        Profile\n                    ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("\n                        Logout\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "hidden-sm",
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v("\n                        Help\n                    ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "visible-sm",
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-question-circle"
  })])], 1)]), _vm._v(" "), (_vm.isAdmin) ? _c('ul', {
    staticClass: "nav-header nav-pills pull-right visible-sm"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-home"
  })])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('inspections')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inspections"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-file"
  })])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('foresters')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foresters"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-tree"
  })])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('profile')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-question-circle"
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isInspector) ? _c('button', {
    staticClass: "btn btn-sm btn-success navbar-btn hidden-xs",
    staticStyle: {
      "margin": "2px 0 0 0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newInspection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus push-5-r"
  }), _vm._v(" New Inspection\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isInspector) ? _c('button', {
    staticClass: "btn btn-sm btn-success navbar-btn pull-right visible-xs",
    staticStyle: {
      "margin": "2px 0 0 0"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newInspection
    }
  }, [_c('i', {
    staticClass: "fa fa-plus push-5-r"
  }), _vm._v(" New Inspection\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav-header nav-pills pull-left"
  }, [_c('li', {
    staticClass: "header-content"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "text-logo"
  }, [_vm._v("CertPilot")]), _vm._v(" "), (_vm.isAdmin) ? _c('span', [_vm._v("  ")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeadingAdmin),
      expression: "isLeadingAdmin"
    }],
    staticClass: "label label-success text-logo-label"
  }, [_vm._v("ADMINISTRATOR")])])], 1)])])]), _vm._v(" "), _c('main', {
    attrs: {
      "id": "main-container"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse remove-padding",
    attrs: {
      "id": "sub-header-nav"
    }
  }, [_c('div', {
    staticClass: "content-mini content-boxed visible-xs"
  }, [_c('ul', {
    staticClass: "nav nav-pills nav-sub-header push"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('home')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home push-5-r"
  }), _vm._v("\n                            Dashboard\n                        ")])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('inspections')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/inspections"
    }
  }, [_c('i', {
    staticClass: "fa fa-file push-5-r"
  }), _vm._v("\n                            Inspections\n                        ")])], 1), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdmin),
      expression: "isAdmin"
    }],
    class: {
      active: _vm.isActiveRoute('foresters')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/foresters"
    }
  }, [_c('i', {
    staticClass: "fa fa-tree push-5-r"
  }), _vm._v("\n                            Foresters\n                        ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-user push-5-r"
  }), _vm._v("\n                            Profile\n                        ")])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out push-5-r"
  }), _vm._v("\n                            Logout\n                        ")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.isActiveRoute('help')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/help"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle push-5-r"
  }), _vm._v("\n                            Help\n                        ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "content content-boxed"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('footer', {
    staticClass: "bg-body font-s12",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "content-mini content-mini-full content-boxed clearfix push-15"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "http://www.woodscamp.com",
      "target": "_blank"
    }
  }, [_vm._v("Woodscamp Technologies Inc.")]), _vm._v(" © "), _c('span', {
    staticClass: "js-year-copy"
  }, [_vm._v(_vm._s(new Date().getFullYear()))])])])]), _vm._v(" "), _c('div', {
    staticClass: "hidden",
    attrs: {
      "id": "busy"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray-lighter visible-xs"
  }, [_c('div', {
    staticClass: "content-mini content-boxed"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default visible-xs push",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#sub-header-nav"
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon push-5-r"
  }), _vm._v("Menu\n                ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b9dbc28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/default.vue
// module id = 828
// module chunks = 3